import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=5d50d0ed"
var script = {}
import style0 from "./divider.vue?vue&type=style&index=0&id=5d50d0ed&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports